import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';
import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { ADD_MANUAL_PRICING, ADD_MANUAL_PRICING_ERROR, ADD_MANUAL_PRICING_SUCCESS } from '../../actions.js';

function* addManualPricing({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/booking/manual-pricing`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: {
        ...payload?.data,
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: ADD_MANUAL_PRICING_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: ADD_MANUAL_PRICING_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: ADD_MANUAL_PRICING_ERROR, payload: error });
  }
}

export function* watchAddManualPricing() {
  yield takeEvery(ADD_MANUAL_PRICING, addManualPricing);
}

function* addManualPricingSaga() {
  yield all([fork(watchAddManualPricing)]);
}

export default addManualPricingSaga;
